import React from 'react';
import ActivationRunGraph from '../ActivationRunGraph';
import { HdIcon } from '../../../../components';
import styles from './styles.module.scss';

function ActivationStatsContainer({ runStageStatsData }) {
  return (
    <div className='center-flex-row'>
      <div className='box p-5 d-flex flex-2 align-items-center'>
        <ActivationRunGraph
          stageInfo={runStageStatsData[0].runStageInfo}
          stageDataPoints={runStageStatsData[0].dataPoints}
        />

        <HdIcon
          name='right-arrow'
          className={styles.statsArrow}
          size={4}
        />

        <ActivationRunGraph
          stageInfo={runStageStatsData[1].runStageInfo}
          stageDataPoints={runStageStatsData[1].dataPoints}
        />
      </div>

      <HdIcon
        name='right-arrow'
        className={styles.statsArrow}
        size={4}
      />

      <div className='box p-5 flex-1'>
        <ActivationRunGraph
          stageInfo={runStageStatsData[2].runStageInfo}
          stageDataPoints={runStageStatsData[2].dataPoints}
        />
      </div>
    </div>
  );
}

export default ActivationStatsContainer;
